export const defaultGroupLabel = ({ name, children }) =>
  `${name} (${children.length})`;
export const defaultGetOptionLabel = ({ name }) => name;
export const defaultGetPrimaryTooltip = ({ name }) => name;

export const defaultGetOptionValue = ({ id }) => id;
